// Attribute mapping to sections for CREDC Employment Land Items
export const attributeMapping = {
  General: ["Jurisdiction", "Number of Parcels", "Gross Acres", "Unconstrained Acres", "Zoning", "Use Restriction"],
  Fundamentals: [
    "Value Ratio ($/sf)",
    "Average Parcel Size",
    "Number of Owners",
    "Market Readiness",
    "Unconstrained Acres - Coverage",
    "Urban Growth Area - Proximity",
    "Urban Industrial Reserve / FDRU Overlay - Proximity",
    "Fundamentals Score",
  ],
  Transportation: [
    "Freight Rail - Coverage",
    "Freight Rail - Proximity",
    "Truck Routes - Coverage",
    "Highway Ramps - Drivetime (Mins)",
    "Transit - Proximity",
    "Transportation Score",
  ],
  "Power Network": [
    "CPU Power - Coverage",
    "CPU Power - Proximity",
    "Power (MVA)",
    "Natural Gas (therms/ hr)",
    "Power Network Score",
  ],
  Broadband: ["Average Download Speed (Mbps)", "Broadband (MB)", "Broadband Score"],
  Water: ["Water District - Ownership", "Water Service - Coverage", "Water Service - Proximity", "Water Score"],
  "Sanitary Sewer": ["Sewer District - Ownership", "Sewer Service - Coverage", "Sewer Service - Proximity", "Sanitary Sewer Score"],
  Environmental: ["Priority Habit Area"],
}